import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import zhtw from "./locales/zhtw.json";
import zh from "./locales/zh.json";


i18n
  .use(initReactI18next)
  .init({
    resources: {
        "en": { translation: en },
        "zh-TW": { translation: zhtw }, 
        "zh": { translation: zh }
      },
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // React already does escaping
    },
  });

export default i18n;
